import { css, html, LitElement } from 'lit'
import { property, customElement } from 'lit/decorators.js'

/**
 * @deprecated use zaptic-radio instead
 * */
@customElement('zaptic-radio-old')
export class RadioOld extends LitElement {
    @property({ type: Boolean, converter: (val) => val !== null })
    selected: boolean = false

    @property({ type: Boolean, converter: (val) => val !== null })
    disabled: boolean = false

    static styles = css`
        input {
            display: none;
        }

        label {
            display: flex;
            align-items: center;
        }

        label:before {
            content: '';
            cursor: pointer;
            background-clip: content-box;

            border-radius: 10px;
            width: 10px;
            height: 10px;
            padding: 4px;
            border: 1px solid var(--grey5);

            margin-right: 8px;
        }

        :hover:not(:disabled):not(:checked) + label:before {
            border-color: var(--grey4);
        }

        :checked:not(:disabled) + label:before {
            border-color: var(--green);
            background-color: var(--green);
        }

        :disabled + label:before {
            cursor: initial;
            pointer-events: none;
        }

        :disabled:not(:checked) + label:before {
            background-clip: initial;
            border-color: var(--grey5);
            background-color: var(--grey8);
        }

        :disabled:checked + label:before {
            border-color: var(--grey5);
            background-color: var(--grey5);
        }

        span {
            /* if there are no slotted children, remove the margin from label:before */
            margin-left: -8px;
        }
    `

    render() {
        return html`
            <input type="radio" id="radio" name="foo" .checked=${this.selected} ?disabled=${this.disabled} />
            <label for="radio">
                <slot><span></span></slot>
            </label>
        `
    }
}
